// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    GENERAL_AUDIT_LOGS_SEARCH_REQUEST,
    GENERAL_AUDIT_LOGS_SEARCH_MODULES_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    generalAuditLogsSearchModulesResult,
    generalAuditLogsSearchResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* searchGeneralAuditlogs({ payload }) {
    const { filters } = payload
    try {
        let QUERY = `
            query searchAuditlogs ($accountId: String, $entity: EntityAuditLogInput, $action: [String], $opensearch: [String], $username: String, $dateRange: AWSDateTimeRange, $nextToken: String, $lastRecords: Int) {
                result: searchAuditlogs (accountId: $accountId, entity: $entity, action: $action, opensearch: $opensearch, username: $username, dateRange: $dateRange, nextToken: $nextToken, lastRecords: $lastRecords) {
                    items {
                        id
                        source
                        urlReferrer
                        module
                        method
                        ipAddress
                        platform
                        entityName
                        entityId
                        accountId
                        action
                        newValues
                        parameters
                        updatedBy
                        updatedOn
                        username
                    }
                    nextToken
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            filters,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data.result) yield put(generalAuditLogsSearchResult(data.result))
        else yield put(generalAuditLogsSearchResult(null))

    } catch (exc) {
        yield put(generalAuditLogsSearchResult(null))
        ExceptionManager(exc, 'Modules/activities/.components/generalDetails/redux/saga.js', 'searchGeneralAuditlogs');
    }
}

function* searchsearchModules() {
    try {
        let QUERY = `
            query searchModules ($conditions: [ModuleSearchInput], $sort: [ModuleSortInput], $limit: Int, $offset: Int) {
                result: searchModules (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        code
                        name
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["projectId"],
                    terms: ["PM", "PX"],
                    exact: true
                },
                sort: {
                    field: "name",
                    order: "ASC"
                },
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(generalAuditLogsSearchModulesResult(data?.result.items))
        } else yield put(generalAuditLogsSearchModulesResult([]))

    } catch (exc) {
        yield put(generalAuditLogsSearchModulesResult([]))
        ExceptionManager(exc, 'Modules/activities/.components/generalDetails/redux/saga', 'searchsearchModules');
    }
}


function* watchMethods() {
    yield takeEvery(GENERAL_AUDIT_LOGS_SEARCH_REQUEST, searchGeneralAuditlogs);
    yield takeEvery(GENERAL_AUDIT_LOGS_SEARCH_MODULES_REQUEST, searchsearchModules);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}